import { Button, Checkbox, Col, Form, Modal, Row, Spin, Input } from 'antd';
import { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import BreadCrumbs from '../../../../common/components/Breadcrumbs';
import { validateMessages } from '../../../../common/constants/common';
import { Page } from '../../../../common/constants/pageAction';
import { getObjectForUpdateMultiple } from '../../../../common/helperFunction';
import { IConfigSoftwareDeviceType } from '../../../../services/master/configSoftwareDeviceType/configSoftwareDeviceType.model';
import { useAppSelector, useAppDispatch } from '../../../../store/app.hooks';
import { updateMultiple } from '../../../../store/common/common.action';
import {
  clearMultipleUpdateMessages,
  commonSelector,
} from '../../../../store/common/common.reducer';
import {
  getConfigSoftwareDeviceTypeById,
  saveConfigSoftwareDeviceType,
} from '../../../../store/master/configSoftwareDeviceType/configSoftwareDeviceType.action';
import {
  clearConfigSoftwareDeviceTypeGetById,
  clearConfigSoftwareDeviceTypeMessages,
  configSoftwareDeviceTypeSelector,
} from '../../../../store/master/configSoftwareDeviceType/configSoftwareDeviceType.reducer';
import { IAddConfigSoftwareDeviceTypeProps } from './addConfigSoftwareDeviceType.model';

const AddConfigSoftwareDeviceTypeModal: React.FC<IAddConfigSoftwareDeviceTypeProps> = (props) => {
  const configSoftwareDeviceType = useAppSelector(configSoftwareDeviceTypeSelector);
  const common = useAppSelector(commonSelector);
  const dispatch = useAppDispatch();
  const { id, showModal, handleModalClose, refreshDataTable, isMultiple, valuesForSelection } =
    props;

  const isNew: boolean = id || isMultiple ? false : true;
  const title = useMemo(() => {
    return (
      <>
        {isNew ? 'Add ' : 'Edit '} <BreadCrumbs pageName={Page.ConfigSoftwareDeviceType} level={1} />
      </>
    );
  }, [isNew]);
  const submitButtonText = useMemo(() => {
    return isNew ? 'Save' : 'Update';
  }, [isNew]);

  const [form] = Form.useForm();

  let initialValues: IConfigSoftwareDeviceType = {
    device_type: '',
  };

  const onFinish = (values: any) => {
    const inputValues: IConfigSoftwareDeviceType = {
      ...values,
      id: id ? +id : null,
    };
    if (!isMultiple) {
      dispatch(saveConfigSoftwareDeviceType(inputValues));
    } else {
      const result = getObjectForUpdateMultiple(
        valuesForSelection,
        inputValues,
        configSoftwareDeviceType.search.tableName
      );
      if (result) {
        dispatch(updateMultiple(result));
      }
    }
  };

  const fillValuesOnEdit = async (data: IConfigSoftwareDeviceType) => {
    if (data) {
      initialValues = {
        device_type: data.device_type,
      };
      form.setFieldsValue(initialValues);
    }
  };

  useEffect(() => {
    if (configSoftwareDeviceType.save.messages.length > 0) {
      if (configSoftwareDeviceType.save.hasErrors) {
        toast.error(configSoftwareDeviceType.save.messages.join(' '));
      } else {
        toast.success(configSoftwareDeviceType.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearConfigSoftwareDeviceTypeMessages());
    }
  }, [configSoftwareDeviceType.save.messages]);

  useEffect(() => {
    if (common.save.messages.length > 0) {
      if (common.save.hasErrors) {
        toast.error(common.save.messages.join(' '));
      } else {
        toast.warn(common.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearMultipleUpdateMessages());
    }
  }, [common.save.messages]);

  useEffect(() => {
    if (+id > 0 && configSoftwareDeviceType.getById.data) {
      const data = configSoftwareDeviceType.getById.data;
      fillValuesOnEdit(data);
    }
  }, [configSoftwareDeviceType.getById.data]);

  useEffect(() => {
    if (+id > 0) {
      dispatch(getConfigSoftwareDeviceTypeById(+id));
    }
    return () => {
      dispatch(clearConfigSoftwareDeviceTypeGetById());
    };
  }, [dispatch]);

  return (
    <>
      <Modal
        wrapClassName="custom-modal"
        title={title}
        centered
        visible={showModal}
        onCancel={handleModalClose}
        footer={false}
      >
        {configSoftwareDeviceType.getById.loading ? (
          <div className="spin-loader">
            <Spin spinning={configSoftwareDeviceType.getById.loading} />
          </div>
        ) : (
          <Form
            form={form}
            name="configSoftwareDeviceType"
            initialValues={initialValues}
            onFinish={onFinish}
            validateMessages={validateMessages}
          >
            <Row gutter={[30, 15]} className="form-label-hide">
            <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'device_type']} valuePropName="checked" noStyle>
                      <Checkbox>Device Type</Checkbox>
                    </Form.Item>
                  ) : (
                    'Device Type'
                  )}
                  <Form.Item
                    name="device_type"
                    label="Device Type"
                    className="m-0"
                    rules={[{ required: !isMultiple, max: 255 }]}
                  >
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <div className="btns-block modal-footer">
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                loading={configSoftwareDeviceType.save.loading || common.save.loading}
              >
                {submitButtonText}
              </Button>
              <Button key="back" onClick={handleModalClose}>
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </>
  );
};
export default AddConfigSoftwareDeviceTypeModal;
